import { Button, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomActiveInactiveRadio from '../../../../shared/form-controls/custom-active-inactive-radio/Custom-Active-Inactive-Radio';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../../utils/formUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { createNewLocation, updateLocationDetails } from '../../../../utils/PropertyAPIUtils';
import { allHotelsSelector, fetchAllLocations } from '../../../property/propertySlice';
import { fetchAllBouquets } from '../../../cms/cmsSlice';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const LocationCreate = (props) => {
  const dispatch = useDispatch();
  const originalHotels = useSelector(allHotelsSelector);
  const { toggleDrawer, location, hotelId, showLoader = () => {} } = props;
  const [loading, setLoading] = useState(false);
  const INTERNAL = 'INTERNAL';
  const EXTERNAL = 'EXTERNAL';
  const [isAddBtnInValid, setIsAddBtnInValid] = useState(true);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Location Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    type: {
      value: '',
      fieldName: 'Type',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
  });

  useEffect(() => {
    if (location) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = location[field];
      }
      setFormData(currFields);
    }
  }, [location]);

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsAddBtnInValid(!isValid);
  }, [formData]);

  const validate = () => {
    const updatedFields = {};

    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      dispatch(stepUpLoaderCount());
      toggleDrawer('', false, '');
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      setLoading(true);
      const payload = {};
      // Populate payload

      for (let field in formData) {
        payload[field] = formData[field].value;
      }
      try {
        if (location) {
          payload.id = location.id;
          await updateLocationDetails(payload, hotelId, language);
          notificationManager('success', 'Location updated successfully');
        } else {
          await createNewLocation(payload, hotelId, language);
          notificationManager('success', 'Location created successfully');
        }

        dispatch(fetchAllLocations(hotelId));
        dispatch(fetchAllBouquets(hotelId));
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          location
            ? notificationManager('danger', 'Location updation failed')
            : notificationManager('danger', 'Location creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Enter all required fields');
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  return (
    <form className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-10'>
            <span className='page-title'>{location ? 'Edit Location' : 'Add Location'}</span>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <h4 className='tab-title'>Details</h4>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                multiline={true}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>
          <div className='row'>
            <h6>Type</h6>
            <div className='col-md-12 mb-3'>
              <CustomActiveInactiveRadio
                item={formData.type}
                handleRadioButton={(e) => {
                  setFormData({ type: e });
                }}
                options={[
                  { id: INTERNAL, name: 'Internal' },
                  { id: EXTERNAL, name: 'External' },
                ]}
                className={'me-5'}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.description}
                handleInputChange={(e) => {
                  setFormData({ description: e });
                }}
                multiline={true}
              />
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              disabled={isAddBtnInValid}
              onClick={handleSubmit}
              variant='contained'
              color='primary'
              className='me-3'
              size='large'
            >
              {location ? 'Update' : 'Add'}
            </Button>
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};
export default LocationCreate;
